import { createContext, useContext } from "react";

const PopoverCloseContext = createContext<() => void>(() => {});

export const PopoverCloseProvider = PopoverCloseContext.Provider;

export const usePopoverClose = () => useContext(PopoverCloseContext);
